import { z } from 'zod'

export const supportRoleSchema = z.enum(['user', 'assistant'])
export type SupportRole = z.infer<typeof supportRoleSchema>

export const supportConversationSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
  platform: z.string().nullable(),
  author: z.string().nullable(),
  startedAt: z.string().nullable(),
  lastActivityAt: z.string().nullable(),
  messageCount: z.number().int().nonnegative(),
  escalated: z.boolean(),
})
export type SupportConversation = z.infer<typeof supportConversationSchema>

export const supportMessageSchema = z.object({
  id: z.number().int(),
  role: supportRoleSchema,
  text: z.string(),
  createdAt: z.string().nullable(),
})
export type SupportMessage = z.infer<typeof supportMessageSchema>

export const supportListResponseSchema = z.object({
  conversations: z.array(supportConversationSchema),
  total: z.number().int().nonnegative(),
  available: z.boolean(),
})
export type SupportListResponse = z.infer<typeof supportListResponseSchema>

export const supportConversationDetailSchema = z.object({
  conversation: supportConversationSchema,
  messages: z.array(supportMessageSchema),
})
export type SupportConversationDetail = z.infer<typeof supportConversationDetailSchema>

export const supportStatsSchema = z.object({
  total: z.number().int().nonnegative(),
  escalated: z.number().int().nonnegative(),
  last7Days: z.number().int().nonnegative(),
})
export type SupportStats = z.infer<typeof supportStatsSchema>
